import {BrochureItem, NewsletterServiceRequest} from "@/types/leads/newsletter-request";
import {Brochure} from "@/types/dto/common/brochure";
import {addCodeToPhone} from "@/utils/phone-utils";

const makeBrochureItems = (brochures: Brochure[]): BrochureItem => brochures
  .reduce((acc, cur) => {
    if (acc[cur.brochureCode]) {
      acc[cur.brochureCode] += acc[cur.brochureCode];
      return acc;
    }
    acc[cur.brochureCode] = 1;
    return acc;
  }, {} as BrochureItem);

const newsletterServiceFactory = (
  data: any,
  marketId: string = "1",
  currencyId: string = "20",
  siteName: string = "collette-us"
): NewsletterServiceRequest => ({
  Title: data?.title ?? "",
  FirstName: data?.firstName ?? "",
  LastName: data?.lastName ?? "",
  Address: data?.address ?? "",
  Address2: data?.address2 ?? "",
  City: data?.city ?? "",
  Zip: data?.zipCode ?? "",
  State: data?.state ?? "",
  Country: data?.country ?? "",
  CurrencyId: currencyId,
  MarketId: marketId,
  SiteName: siteName,
  Email: data?.email ?? "",
  Phone: data?.countryCode && data?.phone
    ? addCodeToPhone(data?.countryCode?.callingCode, data?.phone)
    : (data?.phone ?? ""),
  OptInEmail: data?.optInEmail ?? false,
  IAmAgent: data?.isTravelAgent === "yes",
  WorkingWithAgent: false,
  BrochureItems: Array.isArray(data?.customerLeadBrochures) ? makeBrochureItems(data?.customerLeadBrochures) : {}
});

export default newsletterServiceFactory;